export default __webpack_public_path__ + "static/media/1492509288_settings_ios7_ios_7.a818805f.png";